

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"width":"120","height":"120","viewBox":"0 0 120 120","xmlns":"http://www.w3.org/2000/svg"}, rest), [h('path', {"d":"M90 32.5a5 5 0 015 5v45a5 5 0 01-5 5H30a5 5 0 01-5-5v-45a5 5 0 015-5h60zM86.375 55h-52.75c-1.036 0-1.875.84-1.875 1.875v22c0 1.036.84 1.875 1.875 1.875h52.75c1.036 0 1.875-.84 1.875-1.875v-22c0-1.036-.84-1.875-1.875-1.875zM36.25 38.75a5 5 0 100 10 5 5 0 000-10zm45 2.5h-35c-.69 0-1.25.56-1.25 1.25V45c0 .69.56 1.25 1.25 1.25h35c.69 0 1.25-.56 1.25-1.25v-2.5c0-.69-.56-1.25-1.25-1.25z","fill":"#FFF","fill-rule":"evenodd"}, [])]);
};

        